import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

export const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, IDSelectedRestaurant, IDSelectedCategory } =
		useContext<IDishesContext>(DishesContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || IDSelectedRestaurant || IDSelectedCategory,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};
